import { ReactNode } from 'react'
import cn from 'classnames/bind'

import { Header2, PageTemplateContent } from 'app/common/templates-next/page-template'
import Sticky from 'app/common/templates-next/sticky'

import PaymentOrdersTable from './PaymentOrdersTable'
import styles from './PaymentOrders.module.scss';

const cx = cn.bind(styles)

type Props = {
  header?: string
  school?: {
    id: string | null
    title: string
    isCamp?: boolean
  }
  person: {
    id: number
    name: {
      first: string
      last: string
      middle: string
      gender: 'male' | 'female' | 'androgynous'
    }
    timezone: string
  }
  subNavigation?: ReactNode
  bannerPlaceId?: string
  getPaymentPath?: (s: string) => string
  hideHeader?: boolean
}

const PaymentOrders = ({
  header = 'Квитанции',
  school,
  person,
  subNavigation,
  bannerPlaceId,
  getPaymentPath,
  hideHeader,
}: Props) => {
  const { id: personId } = person
  const { id: schoolId, isCamp } = school || { id: null, isCamp: false }

  return (
    <>
      {!hideHeader && (
        <Sticky>
          {(ref, sticky) => (
            <PageTemplateContent reference={ref} className={cx({ sticky })}>
              <Header2 skipMargin>{header}</Header2>
            </PageTemplateContent>
          )}
        </Sticky>
      )}

      {subNavigation && (
        <Sticky>
          {(ref, sticky) => (
            <PageTemplateContent reference={ref} className={cx({ sticky })}>
              {subNavigation}
            </PageTemplateContent>
          )}
        </Sticky>
      )}

      <PaymentOrdersTable
        personId={personId}
        schoolId={isCamp ? schoolId : undefined}
        bannerPlaceId={bannerPlaceId}
        getPaymentPath={getPaymentPath}
      />
    </>
  )
}

export default PaymentOrders
